import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import Navbar from "./components/appbar";
import Footer from "./components/footer";
import ResumePage from "./pages/ResumePage";
const HomePage = lazy(() => import("./pages/home"));

function App() {

  return (
    <Suspense fallback={<LoaderPage />}>
      <div className="md:text-x">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/my-resume' element={<ResumePage />} />
        </Routes>
        <Footer />
      </div>
    </Suspense>
  );
}

export default App;


function LoaderPage() {
  return (
    <div className="h-screen bg-darkblue text-white flex items-center justify-center">
      <div className="">Loading...</div>
    </div>
  )
}
